if (!customElements.get('collection-information')) {
  class CollectionInformation extends HTMLElement {
    constructor() {
      super();

      this.showMore = this.querySelector('.js-show-more');
      this.description = this.querySelector('.js-collection-description');
      this.firstParagraph = this.description?.firstElementChild;

      this.bindEvents();
    }

    bindEvents() {
      this.toggleContent();
      this.toggleAccordions();
    }

    toggleContent() {
      if (!this.showMore || !this.description || !this.firstParagraph) return;

      // only show first paragraph in render
      this.description.style.maxHeight = `${this.firstParagraph.scrollHeight}px`;

      // attached event
      this.showMore.addEventListener('click', () => {
        if (this.description.classList.contains('is-open')) {
          this.description.classList.remove('is-open');
          this.showMore.classList.remove('is-open');
          this.description.style.maxHeight = `${this.firstParagraph.scrollHeight}px`;
        } else {
          this.showMore.classList.add('is-open');
          this.description.classList.add('is-open');
          this.description.style.maxHeight = `${this.description.scrollHeight}px`;
        }
      });
    }

    toggleAccordions() {
      const accordions = this.querySelectorAll('.js-accordion-toggle');
      if (!accordions) return;

      accordions.forEach((accordion) => {
        accordion.addEventListener('click', () => {
          const parentElement = accordion.parentElement,
            content = accordion.nextElementSibling,
            isOpen = accordion.parentElement.classList.contains('is-open');

          parentElement.classList[isOpen ? 'remove' : 'add']('is-open');
          isOpen
            ? (content.style.maxHeight = null)
            : (content.style.maxHeight = content.scrollHeight + 2000 + 'px');
        });
      });
    }
  }

  customElements.define('collection-information', CollectionInformation);
}
